/** @jsx jsx **/
import { Box, jsx, Text, Button, SxStyleProp } from 'theme-ui'
import { FC, useMemo, useCallback, useState, useEffect } from 'react'
import useMediaQuery from '~/hooks/use-media-query'
import { FilterCategory as FilterCategoryType } from '~/@types/models'
import { Checkbox } from '~/components/checkbox'
import { PlusMinus } from '~/components/icons/plusMinus'

type Props = {
  category: FilterCategoryType
  selectedValues?: Array<{
    name: string
    value: string
  }>
  // sF?: readonly string[]
  titleSx?: SxStyleProp
  moreFiltersSx?: SxStyleProp
  handleChange: (value: { name: string; value: string }, categoryName: string) => void
  showMoreFilters: boolean
}

const FilterCategory: FC<Props> = ({
  handleChange,
  category,
  selectedValues = [],
  moreFiltersSx,
  showMoreFilters,
}) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: breakpoints => `(min-device-width: ${breakpoints[1]})`,
  })
  const [showOptions, setShowOptions] = useState<boolean>(false)
  const [direction, setDirection] = useState<boolean>(false)
  const handleShowCategory = () => {
    setShowOptions(!showOptions)
    setDirection(!direction)
  }

  const isSelected = useCallback(
    (value: string) => {
      return !!selectedValues.filter(selectedValue => selectedValue.value === value).length
    },
    [selectedValues]
  )
  const rotate = (direction: boolean) => {
    switch (direction) {
      case true:
        return `rotate(90deg)`
      default:
        return 'none'
    }
  }

  useEffect(() => {
    if (selectedValues.length) {
      setDirection(true)
      setShowOptions(true)
    }
  }, [selectedValues])

  useEffect(() => {
    setShowOptions(showMoreFilters)
    setDirection(showMoreFilters)
  }, [showMoreFilters])

  return (
    <Box
      sx={{
        width: ['100%', null, showOptions ? 180 : 100],
        borderStyle: ['solid', null, 'unset'],
        borderWidth: ['1px 0', null, 'unset'],
        borderColor: ['border', null, 'unset'],
        // mb: ['-1px', null, null, 'inherit'],
        mx: '20px',
        display: 'flex',
        flexDirection: 'column',
        ...moreFiltersSx,
      }}
    >
      <Button
        sx={{
          backgroundColor: 'white',
          color: 'black',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: ['space-between', null, 'initial'],
          }}
          onClick={handleShowCategory}
        >
          <Text
            as="button"
            variant="label"
            sx={{
              display: 'flex',
              fontSize: '12px !important',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: '#595858',
              backgroundColor: 'transparent',
              border: 0,
              m: 0,
              fontWeight: 400,
              pt: 4,
              paddingLeft: 0,
              mr: '5px',
              a: { visited: '#000000' },
            }}
          >
            {category.label}
            {/* {!isDesktopOrLaptop && <Close />} */}
          </Text>
          <PlusMinus
            sx={{
              mt: 8,
              '#upright': {
                transition: 'all .3s',
                transformOrigin: 'center',
                transform: rotate(direction),
              },
            }}
            color="#666666"
            width={9}
            height={9}
          />
        </Box>
      </Button>
      {showOptions && (
        <Box
          sx={{
            pb: [40, null, null, 0],
            overflow: 'scroll',
            minWidth: '175px',
            overflowX: 'hidden',
            overflowY: 'hidden',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none' /* for Firefox */,
          }}
          style={{ '&::WebkitScrollbar': { width: 0, height: 0 } }}
        >
          {category.items.map(value => {
            return (
              <Checkbox
                key={value.name}
                onChange={() => handleChange(value, category.name)}
                label={value.name}
                checked={isSelected(value.value)}
                name={`${category.label}[${value.name}]`}
                value={isSelected(value.value)}
              />
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default FilterCategory
